import React, {Component} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames';
import querystring from 'query-string'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import autobind from 'autobind-decorator';
import { parseListParams } from '../../common/CommentListHelper';
import ItemAllCheckbox from '../../common/CommentItemAllCheckbox';
import { selectAllItems, deselectAllItems, updateSelectedItems, receiveItems  } from '../../../actions/comment/guestbookCommentTrash'
import WindowEventHelper from "../../../lib/WindowEventHelper";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import TSelectFilter from "../../common/TSelectFilter";
import {addPrefix} from "../../../utils/UriUtil";
import * as InitStatus from '../../../constants/common/InitializationStatus';

@withRouter
@connect(state => ({
    items: state.guestbookCommentTrash.item.items,
    searchKeyword: state.guestbookCommentTrash.condition.searchKeyword,
    searchType: state.guestbookCommentTrash.condition.searchType,
}), dispatch => ({
    handleSelectAllItems: () => {
        dispatch(selectAllItems())
    },
    handleDeselectAllItems: () => {
        dispatch(deselectAllItems())
    },
    handleUpdateSelectedItems: (values) => {
        dispatch(updateSelectedItems(values))
    },
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    dispatch
}))
class GuestBookCommentTrashListHeader extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            optionOpen: false,
            searchOpen: false,
            processing: false,
            deleting: false,
            searching: false,
            searchKeyword : '',
            searchType: 'writer',
            searchTypeOptions : [{ label : '작성자', value: 'writer'}, { label : '내용', value: 'content'}, { label : 'IP', value: 'ip'}],
        };

        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleToggleOption = this.handleToggleOption.bind(this);
        this.handleHideOption = this.handleHideOption.bind(this);
        this.handleOpenSearch = this.handleOpenSearch.bind(this);
        this.handleCloseSearch = this.handleCloseSearch.bind(this);
        this.handleCloseSearchWithKey = this.handleCloseSearchWithKey.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleRestore = this.handleRestore.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.fetchComments = this.fetchComments.bind(this);
    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleHideOption)
		WindowEventHelper.add("keydown", this.handleCloseSearchWithKey)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleHideOption)
		WindowEventHelper.remove("keydown", this.handleCloseSearchWithKey)
    }

    componentWillReceiveProps(nextProps) {
        const { searchKeyword, searchType } = this.state;
        const nextSearchKeyword = nextProps.searchKeyword;
        const nextSearchType = nextProps.searchType;
        if(nextSearchKeyword === '' || (searchKeyword === nextSearchKeyword && searchType === nextSearchType)){
            this.setState({
                searching: false,
            });
        }
    }

    handleSelectAll(e) {
        const { handleSelectAllItems, handleDeselectAllItems } = this.props
        if (e.target.checked) {
            handleSelectAllItems()
        } else {
            handleDeselectAllItems()
        }
    }

    handleToggleOption(e) {
        const { optionOpen } = this.state

        this.setState({
            optionOpen: !optionOpen
        })
    }

    handleHideOption(e) {
        const { btnOptionOpen } = this.refs;
        if (e.target !== btnOptionOpen
            && e.target.parentNode
            && e.target.parentNode !== btnOptionOpen
            && e.target.parentNode.className !== "list_opt"
            && e.target.parentNode.parentNode
            && e.target.parentNode.parentNode.className !== "list_opt") {
            this.setState({
                optionOpen: false
            })
        }
    }

    handleOpenSearch(e) {
        const { searchText } = this.refs;
        searchText.value='';
        this.setState({
            searchOpen: true,
            searchKeyword:'',
            searchType : 'writer',
        });
        setTimeout(() => { searchText.focus() }, 100)

    }

    handleCloseSearch(e) {
        this.setState({
            searchOpen: false
        })
    }

    handleCloseSearchWithKey(e) {

        if (this.state.searchOpen) {
            if(e.keyCode === 27) {
                this.handleCloseSearch()
            }else if(e.keyCode === 13) {
                this.handleSearch();
                this.handleCloseSearch();
            }
        }
    }

    handleSearch() {
        const { searchKeyword, searchType}  = this.state;

        let history = this.props.history;
        let location = this.props.location;

        let listParams = parseListParams(location.search);
        if(listParams.searchKeyword !== searchKeyword || listParams.searchType !== searchType){
            history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword, searchType : searchType}));
            this.setState({
                searching: true,
            });
        }
    }

    handleRestore(e) {
        const { items, dispatch } = this.props;
        let ids = items.filter(item => item.selected).map(item => item.id);
        this.setState({
            processing : true
        });
        this.props.handleSetHeaderStatus(InitStatus.INIT_DOING);

      fetch(addPrefix("/manage/guestBookCommentTrash/restore.json"), {
            method: "post",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify({
                ids: ids.join(",")
            })
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                this.fetchComments();
                this.setState({
                    optionOpen: false
                });
                this.props.handleSetHeaderStatus(InitStatus.INIT_SUCCESS);

            })
            .catch(e => {
                console.log(e);
                this.setState({
                    processing : false
                });
                this.fetchComments();
                this.props.handleSetHeaderStatus(InitStatus.INIT_FAIL);
            })
    }

    handleDelete(e) {

        if(confirm('선택한 댓글을 완전히 삭제하시겠습니까?')){

        const { items, handleUpdateSelectedItems, dispatch } = this.props;
        let ids = items.filter(item => item.selected).map(item => item.id);
        handleUpdateSelectedItems({ deleting : true});
        this.setState({
            deleting: true
        });

        this.props.handleSetHeaderStatus(InitStatus.INIT_DOING);
        fetch(addPrefix("/manage/guestBookCommentTrash.json"), {
            method: "delete",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify({
                ids: ids.join(",")
            })
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                this.fetchComments();
                this.setState({
                    optionOpen: false
                });
                this.props.handleSetHeaderStatus(InitStatus.INIT_SUCCESS);
            })
            .catch(e => {
                console.log(e);
                handleUpdateSelectedItems({ deleting : false});
                this.setState({
                    optionOpen: false,
                    deleting : false
                });
                this.fetchComments();
                this.props.handleSetHeaderStatus(InitStatus.INIT_FAIL);
            })
        }
    }

    fetchComments() {
        const { handleReceiveItems, dispatch } = this.props;
        fetch(addPrefix("/manage/guestBookCommentTrash.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                handleReceiveItems(data.items, data.totalCount);
                this.setState({
                    optionOpen: false,
                    deleting : false,
                    processing : false,
                    searching: false
                });
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    optionOpen: false,
                    deleting : false,
                    processing : false,
                    searching : false
                });
            })
    }

    searchUpdated (event) {
        const keyword = event.target.value;
        this.setState({searchKeyword: keyword})
    }

    @autobind
    selectSearchType(item, idx) {

        this.setState({
            searchType: item.value
        })
    }

    render() {

        const { optionOpen, searchOpen, searchKeyword, searchType, searchTypeOptions, deleting, processing, searching } = this.state;
        const { items } = this.props;

        let selectedCount = items.filter(item => item.selected).length;
        let searchable = searchKeyword.length > 0;
        let optionAvailable = selectedCount > 0;

        if(searching) {
            return (<div className="wrap_search loading_search">
                <TSelectFilter className={"filter_search"} items={searchTypeOptions} disabled={true}
                               selected={searchType}
                               onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
                <em className="txt_keyword">{searchKeyword}</em>
                <span className="txt_change">
                        검색중
                        <span className="ico_blog ico_change"/>
                    </span>
            </div>);
        }

        return (<div className={classnames({
            "wrap_search": true,
            "on": searchOpen
        })}>
            <ItemAllCheckbox items={items} handleSelectAll={this.handleSelectAll}/>
            <div className="search_blog">
                <TSelectFilter className={"filter_search"} items={searchTypeOptions}
                               selected={searchType}
                               onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
                <input type="text" className="tf_search" title="검색어 입력" placeholder="방명록 휴지통에서 검색합니다." ref="searchText" onChange={(e) => this.searchUpdated(e)} />
                <div className="info_search">
                    <Link to="/guestbook" className="btn_search">방명록 관리<span className="ico_blog ico_arr"/></Link>
                    <button type="button" className="btn_search" onClick={this.handleOpenSearch}>
                        검색
                        <span className="ico_blog ico_search"> 열기</span>
                    </button>
                    <button type="button" className="btn_search btn_query" disabled={!searchable} onClick={this.handleSearch}>
                        <span className="ico_blog ico_search">검색 하기</span>
                    </button>
                    <button type="reset" className="btn_del" onClick={this.handleCloseSearch}>닫기</button>
                </div>
            </div>
            <div className={classnames({
                "opt_blog": true,
                "opt_open": optionOpen,
                "change_on" : ( processing || deleting)
            })}>
                <button ref="btnOptionOpen" type="button" className="btn_opt" disabled={!optionAvailable} onClick={this.handleToggleOption}>
                    변경
                    <span className="ico_blog ico_open" />
                </button>
                <span className="txt_change">
                    { processing && "변경중"}
                    { deleting && "삭제중"}
                    <span className="ico_blog ico_change"/>
                </span>
                <div className="layer_opt">
                    <ul className="list_opt">
                        <li>
                            <label className="lab_btn">
                                복구
                                <input type="button" className="btn_g" value="복구" onClick={this.handleRestore}/>
                            </label>
                        </li>
                        <li>
                            <label className="lab_btn">
                                완전 삭제
                                <input type="button" className="btn_g" value="완전 삭제" onClick={this.handleDelete}/>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>);

        }
}

export default GuestBookCommentTrashListHeader;
